import TagManager from 'react-gtm-module';
import { MessageApiProvider } from "./contexts/MessageContext";
import { ApiProvider } from "./contexts/SessionContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import "./index.css"
import { ToastContainer } from "react-toastify";
import { LoaderProvider } from "./hooks/useLoader";
import { Routes } from "./routes/Routes";
const CHAVE = '@usemaisbrasil';

localStorage.removeItem('@assistamais');
sessionStorage.removeItem('@assistamais');

const tagManagerArgs = {
  gtmId: 'GTM-PS26QK2'
}
TagManager.initialize(tagManagerArgs)

const clientId = '175857597463-qsf2pu0o23camne76motu6r3rtf6m9sm.apps.googleusercontent.com';

function App() {

  window.dataLayer.push({
    event: 'pageview'
  });  

  return (
    <Provider store={store}>
      <LoaderProvider>
        <ApiProvider>
          <MessageApiProvider>
            <GoogleOAuthProvider clientId={clientId}>
              <Routes />
            </GoogleOAuthProvider>
          </MessageApiProvider>
        </ApiProvider>
      </LoaderProvider>
      <ToastContainer 
        position="top-right"
        theme="colored"
      />
    </Provider>
  );
}

export default App;
